module.exports = __webpack_public_path__ + "static/images/containers/Landing/components/LandingClans/components/Card/components/Back/images/shadow.775a3a2c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/LandingClans/components/Card/components/Back/images/shadow.png
// module id = 3120
// module chunks = 11